import script from "./ShuttleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ShuttleItem.vue?vue&type=script&setup=true&lang=js"

import "./ShuttleItem.vue?vue&type=style&index=0&id=de4d3b56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de4d3b56"]])

export default __exports__